import { render, staticRenderFns } from "./PendingTenantInvitations.vue?vue&type=template&id=36ab0f78&scoped=true&"
import script from "./PendingTenantInvitations.vue?vue&type=script&lang=js&"
export * from "./PendingTenantInvitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ab0f78",
  null
  
)

export default component.exports